import { Plus } from 'lucide-react';

import { Button } from '../../ui/catalyst/button';
import { Heading } from '../../ui/catalyst/heading';
import { Text } from '../../ui/catalyst/text';

interface EmptyStateProps {
  onCreateThread: () => void;
}

export const EmptyState = ({ onCreateThread }: EmptyStateProps) => {
  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-center p-4">
        <Heading level={4}>Select a thread or create a new one</Heading>
        <Text className="mt-2 text-gray-500">
          Select an existing thread from the sidebar or create a new one to
          start chatting.
        </Text>
        <Button className="mt-4 flex items-center" onClick={onCreateThread}>
          <Plus className="h-4 w-4 mr-1" />
          New Thread
        </Button>
      </div>
    </div>
  );
};
